<template>
  <router-link
    :to="to"
    class="simple-button"
  >
    <slot />
    <span class="icon decors-icons-cta-arrow" />
  </router-link>
</template>

<script>


export default {
  name: 'SimpleButton',
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
  },
};
</script>

<style lang="stylus" scoped>
.simple-button {
  display: flex;
  align-items: center;
  border: 1px solid white;
  cursor: pointer;
  color: white;
  width: fit-content;
  padding: 10px 30px;
  border-radius: 6px;
  background: $cl-blue;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.70);
  font-size: 20px;
  letter-spacing: 1px;
  font-weight: 700;
  gap: 10px;
  transition: all 0.3s ease-in-out;

  .icon {
    transition: transform 0.3s ease-in-out;
  }

  &:hover {
    background: $cl-dark-blue;

    .icon {
      transform: translateX(5px);
    }
  }
}

</style>
